module.exports = __webpack_public_path__ + "img/transport-badge.21511acd.png";